// extracted by mini-css-extract-plugin
export default {"container":"DisplayNameChangePage_container__0MK+M"};